export default __webpack_public_path__ + "static/media/eye-off.fa0abd51.svg";